import { render } from "./EditComp.vue?vue&type=template&id=4c4942f6&scoped=true"
import script from "./EditComp.vue?vue&type=script&lang=js"
export * from "./EditComp.vue?vue&type=script&lang=js"

import "./EditComp.vue?vue&type=style&index=0&id=4c4942f6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4942f6"]])

export default __exports__